import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * URLDebugger - A component to help debug Firebase auth action URLs
 * This can be temporarily added to pages to see what parameters Firebase is sending
 */
const URLDebugger: React.FC = () => {
  const location = useLocation();
  const [debugInfo, setDebugInfo] = useState<any>({});

  useEffect(() => {
    const fullUrl = window.location.href;
    const searchParams = new URLSearchParams(location.search);
    const hashParams = window.location.hash ? new URLSearchParams(window.location.hash.substring(1)) : null;
    
    const info = {
      timestamp: new Date().toISOString(),
      fullUrl,
      pathname: location.pathname,
      search: location.search,
      hash: window.location.hash,
      searchParams: Object.fromEntries(searchParams.entries()),
      hashParams: hashParams ? Object.fromEntries(hashParams.entries()) : null,
      userAgent: navigator.userAgent,
      referrer: document.referrer,
    };
    
    setDebugInfo(info);
    console.log('URL Debug Info:', info);
  }, [location]);

  // Only show in development or when there are auth-related parameters
  const searchParams = new URLSearchParams(location.search);
  const hasAuthParams = searchParams.get('mode') || searchParams.get('oobCode') || searchParams.get('continueUrl');
  
  if (process.env.NODE_ENV === 'production' && !hasAuthParams) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      right: 0,
      width: '300px',
      maxHeight: '400px',
      backgroundColor: '#f0f0f0',
      border: '1px solid #ccc',
      padding: '10px',
      fontSize: '12px',
      overflow: 'auto',
      zIndex: 9999,
      opacity: 0.9
    }}>
      <h4>URL Debug Info</h4>
      <pre style={{ fontSize: '10px', overflow: 'auto' }}>
        {JSON.stringify(debugInfo, null, 2)}
      </pre>
    </div>
  );
};

export default URLDebugger;
